import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import ProductActions from 'actions/ProductActions';
import Actions from 'actions/Actions';
import { createSelector } from 'reselect';
import localeUtils from 'utils/LanguageLocale';
import Location from 'utils/Location';
import completePurchaseHistorySelector from 'selectors/completePurchaseHistory/completePurchaseHistorySelector';
import { showPurchasedFlagOnGridPagesSelector } from 'viewModel/selectors/testTarget/showPurchasedFlagOnGridPagesSelector';

import { showAddBestsellersOnGridPagesSelector } from 'viewModel/selectors/testTarget/showAddBestsellersOnGridPagesSelector';
import { showSkuOptionsPLPSelector } from 'viewModel/selectors/testTarget/showSkuOptionsPLPSelector';
import { showUpdateQuickLookModalSelector } from 'viewModel/selectors/testTarget/showUpdateQuickLookModalSelector';
import chooseOptionsActions from 'actions/ChooseOptionsActions';

const { wrapHOC } = FrameworkUtils;
const { showSimilarProductsModal } = Actions;

const { fireProductViewableImpressionTracking, fireSponsoredProductClickTracking } = ProductActions;

const fields = createSelector(
    completePurchaseHistorySelector,
    showPurchasedFlagOnGridPagesSelector,
    showAddBestsellersOnGridPagesSelector,
    showSkuOptionsPLPSelector,
    showUpdateQuickLookModalSelector,
    (completePurchaseHistory, showPurchasedFlagOnGridPages, showAddBestsellersOnGridPages, showSkuOptionsPLP, showUpdateQuickLookModal) => {
        return {
            completePurchaseHistory,
            showPurchasedFlagOnGridPages,
            showAddBestsellersOnGridPages,
            showSkuOptionsPLP,
            showUpdateQuickLookModal,
            shouldShowPercentageOffBadge: localeUtils.isUS() && Location.isSalePage()
        };
    }
);

const functions = {
    fireProductViewableImpressionTracking,
    fireSponsoredProductClickTracking,
    showSimilarProductsModal,
    showChooseOptionsModal: chooseOptionsActions.showChooseOptionsModal
};

const withProductTileProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withProductTileProps
};
